import { useEffect, RefObject } from "react";

type OutsideClickHandler = (event: MouseEvent) => void;

function useOutsideClick(
  ref: RefObject<HTMLElement>,
  handleOutsideClick: OutsideClickHandler
): void {
  useEffect(() => {
    function handleClick(event: MouseEvent): void {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        handleOutsideClick(event);
      }
    }

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [ref, handleOutsideClick]);
}

export default useOutsideClick;
